import React from "react";
// import { Button, Card, Col, Form, Input, message, Row, Spin } from "antd";
import { useAuthContext } from "../../context/AuthContext";
// import { API } from "../constant";
import { useState, useEffect } from "react";
import { getToken } from "../../helpers/authHelpers";
import "./profile.css";
import axios from "axios";
import BlogSettings from "../../components/blogSettings/BlogSettings";

const Profile = () => {
  const { user, isLoading, setUser } = useAuthContext();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    twitter_username: "",
    linkedin_username: "",
    github_username: "",
    // avatar_url: "",
    profilePic: "",
    website_url: "",
    about: "",
  });

  const [message, setMessage] = useState("");
  const [filePreview, setFilePreview] = useState(null);
  // console.log("fileprevie" + JSON.stringify(formData));

  useEffect(() => {
    if (user) {
      setFormData({
        username: user.username || "",
        email: user.email || "",
        twitter_username: user.twitter_username || "",
        linkedin_username: user.linkedin_username || "",
        github_username: user.github_username || "",
        // avatar_url: user.avatar_url || "",
        profilePic: user.profilePic || "",
        website_url: user.website_url || "",
        about: user.about || "",
      });

      const previewUrl =
        process.env.REACT_APP_UPLOAD_URL + user.profilePic?.url;
      setFilePreview(previewUrl);
    }
  }, [user]);

  // useEffect(() => {
  //   if (formData.profilePic && typeof formData.profilePic === "object") {
  //     const previewUrl =
  //       process.env.REACT_APP_UPLOAD_URL + formData.profilePic?.url;
  //     setFilePreview(previewUrl);

  //     // return () => URL.revokeObjectURL(previewUrl); // Cleanup
  //     // } else if (formData.avatar_url) {
  //     //   setFilePreview(formData.avatar_url);
  //   } else {
  //     setFilePreview(null);
  //   }
  // }, []);

  //Clean up file preview URL on unmount
  useEffect(() => {
    return () => {
      if (filePreview) URL.revokeObjectURL(filePreview);
    };
  }, [filePreview]);

  // const handleChange = (e) => {
  //   const { name, value, files } = e.target;

  //   if (name === "profilePic") {
  //     const file = files[0];
  //     if (!file) return;

  //     // File validation: max 2MB and must be image
  //     const isImage = file.type.startsWith("image/");
  //     const isLt2M = file.size / 1024 / 1024 < 2;

  //     if (!isImage) {
  //       setMessage("Only image files are allowed.");
  //       return;
  //     }

  //     if (!isLt2M) {
  //       setMessage("Image must be smaller than 2MB.");
  //       return;
  //     }

  //     // Show preview
  //     setFormData((prev) => ({
  //       ...prev,
  //       profilePic: file,
  //       avatar_url: "",
  //     }));
  //   } else {
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  // };

  const handleChange = (e) => {
    const file = e.target.files?.[0];

    if (file && file.type.startsWith("image/")) {
      // Clean up old preview
      if (filePreview) URL.revokeObjectURL(filePreview);

      const previewUrl = URL.createObjectURL(file);

      setFormData((prev) => ({
        ...prev,
        profilePic: file,
        // avatar_url: "", // clear if needed
      }));

      setFilePreview(previewUrl);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    if (!formData.username || !formData.email) {
      setMessage("Username and Email are required.");
      setLoading(false);
      return;
    }

    try {
      let imageData = null;

      if (formData.profilePic && typeof formData.profilePic !== "string") {
        const result = await sendImage(formData.profilePic);
        if (result?.uploadSuccess) {
          imageData = result.imageRes;
        }
      }

      const updatedData = {
        ...formData,
        profilePic: imageData ? imageData : formData.profilePic,
      };

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/users/${user.id}`,
        updatedData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );

      setUser(response.data);
      setMessage("Profile updated successfully!");
    } catch (error) {
      console.error(error);
      setMessage("Error while updating the profile.");
    } finally {
      setLoading(false);
    }
  };

  async function sendImage(file) {
    if (file && typeof file !== "string") {
      const formDataToSend = new FormData();
      formDataToSend.append("files", file);
      try {
        const uploadResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/upload`,
          formDataToSend,
          {
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          }
        );
        const uploadedFile = uploadResponse.data[0];
        return {
          imageRes: uploadedFile,
          uploadSuccess: true,
        };
      } catch (error) {
        console.log("sendImageError: " + error);
      }
    }
  }

  const handleRemoveImage = () => {
    setFormData((prev) => ({
      ...prev,
      // avatar_url: "",
      profilePic: "",
    }));
    setFilePreview("");
  };

  if (isLoading) return <div>Loading user info...</div>;

  return (
    <div className="profile-container">
      <h2>Profile Settings</h2>
      {message && <p>{message}</p>}
      <form onSubmit={handleSubmit}>
        <div className="row">
          <label>
            Username*:
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Email*:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>
        </div>
        <div className="d-flex flex-row gap-2 justify-content-center">
          {filePreview ? (
            <>
              <img
                className="previewImg"
                src={filePreview}
                alt="Profile Preview"
              />
              <button type="button" onClick={handleRemoveImage}>
                Remove Image
              </button>
            </>
          ) : (
            <p>No image selected</p>
          )}

          <div className="column">
            {/* <label>
              Avatar URL:
              <input
                type="url"
                name="avatar_url"
                value={formData.avatar_url}
                onChange={handleChange}
              />
            </label> */}
            <label htmlFor="fileInput">
              Upload Avatar image
              <i className="writeIcon fas fa-plus"></i>
              <input
                id="fileInput"
                type="file"
                name="profilePic"
                onChange={handleChange}
                style={{ display: "none" }}
              />
            </label>

            <p>{filePreview}</p>
          </div>
        </div>

        <div className="row">
          <label>
            Twitter Username:
            <input
              type="text"
              name="twitter_username"
              value={formData.twitter_username}
              onChange={handleChange}
            />
          </label>

          <label>
            LinkedIn Username:
            <input
              type="text"
              name="linkedin_username"
              value={formData.linkedin_username}
              onChange={handleChange}
            />
          </label>

          <label>
            GitHub Username:
            <input
              type="text"
              name="github_username"
              value={formData.github_username}
              onChange={handleChange}
            />
          </label>

          <label>
            Website URL:
            <input
              type="url"
              name="website_url"
              value={formData.website_url}
              onChange={handleChange}
            />
          </label>
        </div>

        <div className="row">
          <label>
            About Author:
            <textarea
              name="about"
              value={formData.about}
              onChange={handleChange}
            ></textarea>
          </label>
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </button>
      </form>

      <BlogSettings />
    </div>
  );
};

export default Profile;
